export default __webpack_public_path__ + "static/media/pokemon-logo.31adb9eb.png";